import { SxProps, TextField, Typography } from '@mui/material'
import React, { forwardRef, useEffect, useState } from 'react'
import { currencyToNumber, maskCurrency } from '../../utils/maks'
import { CoinInfo, CoinType, useCoin } from '../../context/coin_context'
import { useTranslation } from 'react-i18next'

interface Props {
    value: number
    setValue(v: number): void
    label: string
    sx?: SxProps
    error?: string
    onClick?(): void
    onBlur?(): void
    size?: 'small' | 'medium'
    endAdornment?: JSX.Element
    maxValue?: number
    coin?: CoinInfo
    digits?: number
    fontSize?: string
    id?: string
    onKeyDown?(e: React.KeyboardEvent): void
    disabled?: boolean
}

export const CurrencyField = forwardRef<HTMLInputElement, Props>(
    (
        {
            value,
            setValue,
            label,
            sx,
            error,
            onClick,
            onBlur,
            size,
            endAdornment,
            maxValue,
            coin,
            digits = 2,
            fontSize = '16px',
            id,
            onKeyDown,
            disabled,
        }: Props,
        ref
    ) => {
        const { t } = useTranslation()
        const { coins } = useCoin()
        const [localValue, setLocalValue] = useState('')

        const selectedCoin = coin ? coin : coins[0]

        useEffect(() => {
            setLocalValue(maskCurrency(value, selectedCoin))
        }, [value, selectedCoin])

        return (
            <TextField
                sx={{
                    ...sx,
                }}
                error={Boolean(error)}
                helperText={error}
                onClick={onClick}
                onBlur={onBlur}
                value={localValue}
                label={t(label)}
                disabled={disabled}
                onChange={(e) => {
                    let newValue = e.target.value.replace(/\D/g, '')
                    let numberValue

                    if (selectedCoin?.hideDecimal) {
                        numberValue = Number(newValue)
                    } else {
                        const divider = 100 * Math.pow(10, digits - 2)
                        numberValue = Number(newValue) / divider
                    }

                    if (typeof maxValue === 'number' && numberValue > maxValue)
                        return
                    if (value === numberValue) return
                    setValue(numberValue)
                }}
                onKeyDown={onKeyDown}
                inputRef={ref}
                InputProps={{
                    id: id,
                    startAdornment: (
                        <Typography
                            sx={{
                                mr: '5px',
                                whiteSpace: 'nowrap',
                                fontSize: fontSize,
                            }}
                        >
                            {selectedCoin?.symbol}
                        </Typography>
                    ),
                    endAdornment: endAdornment,
                    style: {
                        fontSize: fontSize,
                    },
                }}
                size={size}
            />
        )
    }
)
